export default {
  state: {
    forgetEmail: "",
    newPassword: false,
    isOpenTariffModel: false,
    paymentModal: false,

    modalBuy: false,
    modalBuyLoad: false,

    modalLoader: false,

    confirmModal: false,

    fromSaveButton: false,

    forgetPassword: false,
    uploadPhoto: false,
    uploadPhotoCv: false,
    changePassword: false,
    loginModal: false,
    cvDownload: {show: false, cv: null},
    openShareModal: {show: false, type: null},
    yandexMap: {
      show: false
    },
    googleMap: {},
    newMessage: {
      show: false,
      type: "success",
      messageTitle: "",
      message: ""
    },

    downloadFormat:'pdf'
  },
  mutations: {
    cvDownload(state, param = {show: false, cv: null}) {
      state.cvDownload = param;
    },
    openShareModal(state, param = {show: false, type: null}) {
      state.openShareModal = param;
    },
    newPassword(state, param) {
      if (!param) {
        state.forgetEmail = "";
      }
      state.newPassword = param;
    },
    isOpenTariffModel(state, param) {
      if (!param) {
        state.tariff = {};
      }
      state.isOpenTariffModel = param;
    },
    isOpenConfirmModal(state, param) {
      state.confirmModal = param;
    },
    paymentModal(state, isOpen) {
      state.paymentModal = isOpen;
    },

    modalBuy(state, isOpen) {
      state.modalBuy = isOpen;
    },
    modalBuyLoad(state, isOpen) {
      state.modalBuyLoad = isOpen;
    },
    modalLoader(state, isOpen) {
      state.modalLoader = isOpen;
    },

    forgetPassword(state, param) {
      state.loginModal = false;
      state.forgetPassword = param;
    },
    changePassword(state, param) {
      state.changePassword = param;
    },
    loginModal(state, param) {
      state.loginModal = param;
    },
    uploadPhoto(state, param) {
      state.uploadPhoto = param;
    },
    uploadPhotoCv(state, param) {
      state.uploadPhotoCv = param;
    },
    fromSaveButton(state, param) {
      state.fromSaveButton = param;
    },
    newMessage(
      state,
      params = {
        show: false,
        type: "success",
        messageTitle: "",
        message: ""
      }
    ) {
      state.newMessage = params;
    },
    yandexMap(state, params = {show: false}) {
      state.yandexMap = params;
    },
    downloadFormat(state,param){
      state.downloadFormat = param
    }
  },
  getters: {
    cvDownload: state => {
      return state.cvDownload;
    },
    openShareModal: state => {
      return state.openShareModal;
    },
    avatar: state => key => {
      return state[key];
    },
    newPassword: state => {
      return state.newPassword;
    },
    isOpenTariffModel: state => {
      return state.isOpenTariffModel;
    },
    isOpenConfirmModal: state => {
      return state.confirmModal
    },
    paymentModal: state => {
      return state.paymentModal;
    },

    fromSaveButton:state =>{
        return state.fromSaveButton;
    },

    modalBuy: state => {
      return state.modalBuy;
    },
    modalBuyLoad: state => {
      return state.modalBuyLoad;
    },
    modalLoader: state => {
      return state.modalLoader;
    },

    forgetPassword: state => {
      return state.forgetPassword;
    },
    loginModal: state => {
      return state.loginModal;
    },
    newMessage: state => {
      return state.newMessage;
    },
    uploadPhoto: state => {
      return state.uploadPhoto;
    },
    uploadPhotoCv: state => {
      return state.uploadPhotoCv;
    },
    changePassword: state => {
      return state.changePassword;
    },
    yandexMap: state => {
      return state.yandexMap;
    },
    downloadFormat: state => {
      return state.downloadFormat
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/modals.js